import * as React from 'react';

/**
 * CoreComponent component
 * @extends {React.PureComponent<IScriptInjectorProps>}
 */
declare global {
    interface Appcues {
        identify(userId: string, opts?: string | { language?: string; [key: string]: any }): void;
    }

    interface Window {
        Appcues?: Appcues;
    }
}

class Master extends React.PureComponent {
    constructor(props: {}) {
        super(props);
    }

    public render(): JSX.Element | null {
        return <script />;
    }
}

export default Master;
